import classNames from 'classnames';
import { mergeStyles, sizeClassName as sizeClassNameFromCommon } from 'wix-rich-content-common';
import viewerStyles from './styles/video-viewer.scss';
export const containerClassName = (theme = {})=>{
    const mergedStyles = mergeStyles({
        styles: viewerStyles,
        theme
    });
    return mergedStyles.video_container;
};
export const sizeClassName = (componentData, theme, styles, isMobile)=>{
    const className = sizeClassNameFromCommon(componentData, theme, styles, isMobile, '');
    return classNames(className, theme['videoPlugin']);
};
